import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import SubHeader from "./SubHeader";
import { Box } from "@mui/material";
import { ProfileProvider } from "../../context/ProfileContext";

const Layout = ({ children }) => {
  return (
    <ProfileProvider>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <SubHeader />
        <Box component="main" sx={{ flex: 1 }}>
          {children}
        </Box>
        <Footer />
      </Box>
    </ProfileProvider>
  );
};

export default Layout;
